import React, { FunctionComponent } from 'react'
import PuxMediaSelector, {
  PuxMediaSelectorType,
} from 'Root/Shared/components/content/mediaImage/PuxMediaSelector'
import EasySoftwareEditorContainer from 'Root/Shared/components/EasySoftwareEditorContainer/EasySoftwareEditorContainer'
import {
  PuxWysiwygHtmlBodyType,
} from 'Shared/components/PuxWysiwyg/PuxWysiwyg'

import PuxButton, { PuxButtonType } from '../PuxButton/PuxButton'

export interface EasySoftwareHeroBannerItemPictureType {
  contentItemId: string
  contentType: string
  displayText: string
  heroBannerItemPictureContent: PuxWysiwygHtmlBodyType
  heroBannerItemPictureButton1: PuxButtonType
  heroBannerItemPictureButton2: PuxButtonType
  puxMediaSelector: PuxMediaSelectorType
}

export interface EasySoftwareHeroBannerItemPictureProps {
  data: EasySoftwareHeroBannerItemPictureType
  pageContentItemId: string
  editorPath: string
}

const EasySoftwareHeroBannerItemPicture: FunctionComponent<EasySoftwareHeroBannerItemPictureProps> = (
  props
) => {
  const primaryButton = props.data.heroBannerItemPictureButton1,
    secondaryButton = props.data.heroBannerItemPictureButton2,
    hasPrimaryButton = Boolean(primaryButton?.buttonLink.text?.[0]),
    hasSecondaryButton = Boolean(secondaryButton?.buttonLink.text?.[0]),
    classes = [`HeroBannerItem`]

  return (
    <div className={classes.join(` `)}>
      <div className='HeroBannerItem-image'>
        <PuxMediaSelector
          {...props.data.puxMediaSelector}
          width={800}
          height={470}
          disableLazyload={true}
        />
      </div>
      <div className='HeroBannerItem-text'>
        <EasySoftwareEditorContainer pageContentItemId={props.pageContentItemId} content={props.data.heroBannerItemPictureContent} editorPath={props.editorPath} wysiwygId={props.data.contentItemId} />
        {(hasPrimaryButton || hasSecondaryButton) && (
          <div className='HeroBannerItem-buttons'>
            {hasPrimaryButton && <PuxButton {...primaryButton} />}
            {hasSecondaryButton && <PuxButton {...secondaryButton} />}
          </div>
        )}
      </div>
    </div>
  )
}

export default EasySoftwareHeroBannerItemPicture
